export const STATUS = {
  PENDING    : 'pending',
  PROCESSING : 'processing',
  SHIPPED    : 'shipped',
  COMPLETED  : 'completed',
  CANCELLED  : 'cancelled'
}

export const PAYMENT_STATUS = {
  PENDING            : 'pending',
  PENDING_SETTLEMENT : 'pending_settlement',
  COMPLETED          : 'completed',
  FAILED             : 'failed',
  EXPIRED            : 'expired',
  CANCELLED          : 'cancelled'
}

export const SHIPMENT_PROGRESS_STATUS = {
  PENDING    : 'pending',
  PROCESSING : 'processing',
  COMPLETED  : 'completed',
  CANCELLED  : 'cancelled'
}

export const SHIPMENT_STATUS = {
  PENDING   : 'pending',
  SHIPPED   : 'shipped',
  COMPLETED : 'completed',
  CANCELLED : 'cancelled',
  FAILED    : 'failed',
  RETURNED  : 'returned'
}

export const REFUND_STATUS = {
  NOT_APPLICABLE : 'not_applicable',
  PARTIAL        : 'partial',
  FULL           : 'full'
}

export const ITEM_STATUS = {
  ORDERED           : 'ordered',
  PAID              : 'paid',
  CONFIRM_COD       : 'confirm_cod',
  SHIPPED           : 'shipped',
  DELIVERED         : 'delivered',
  SHIPMENT_FAILED   : 'shipment_failed',
  COMPLETED         : 'completed',
  REFUND_PROCESSING : 'refund_processing',
  REFUNDED          : 'refunded',
  CANCELLED         : 'cancelled'
}


/** Custom Order Item status constant for refundable order item */
export let REFUNDABLE_ORDER_ITEM_STATUS = {
  ops_before_shipping: {
    [ITEM_STATUS.PAID.toUpperCase()]            : ITEM_STATUS.PAID,
    [ITEM_STATUS.SHIPMENT_FAILED.toUpperCase()] : ITEM_STATUS.SHIPMENT_FAILED
  },
  cs: {
    [ITEM_STATUS.SHIPPED.toUpperCase()]   : ITEM_STATUS.SHIPPED,
    [ITEM_STATUS.DELIVERED.toUpperCase()] : ITEM_STATUS.DELIVERED,
    [ITEM_STATUS.COMPLETED.toUpperCase()] : ITEM_STATUS.COMPLETED
  }
}

export const REFUND_REASON = {
  SOLD_BUT_LIVE         : 'sold_but_live',
  SOLD_BUT_LIVE_SCRAPER : 'sold_but_live_scraper',
  QUALITY_DECREASES     : 'quality_decreases',
  SCRAPPING_TOO_LONG    : 'scrapping_too_long',
  SHIPPING_FEE          : 'shipping_fee',
  DIRTY_ITEM            : 'dirty_item',
  RETUR_ITEM            : 'retur_item',
  OTHERS                : 'others'
}

export const REFUND_METHOD = {
  CASH         : 'cash',
  CREDIT_CARD  : 'credit_card',
  KREDIVO      : 'kredivo',
  GOPAY        : 'gopay',
  VOUCHER_CODE : 'voucher_code'
}

export const RESOLUTION_ACTION = {
  PENDING               : 'pending',
  BACK_TO_LOCATION      : 'back_to_location',
  RETURN_TO_VENDOR      : 'return_to_vendor',
  SOLD_BUT_LIVE         : 'sold_but_live',
  SOLD_BUT_LIVE_SCRAPER : 'sold_but_live_scraper',
  RE_CURATE             : 're_curate',
  BOUGHT_BY_TL          : 'bought_by_tl',
  ITEM_WRONG_PRICE      : 'item_wrong_price'
}

export const SHIPMENT_METHOD = {
  ANTER_AJA: 'Anter Aja'
}

export const DOCUMENT_TEMPLATES = {
  TINKERLUST : 'tinkerlust',
  ZALORA     : 'zalora'
}

export const AFFILIATE_NAMES = {
  TINKERLUST : 'tinkerlust',
  ZALORA     : 'zalora'
}
